import Vue from 'vue';

Vue.filter('avatar', (val) => val ? val.charAt(0) : 'A');